'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _WixComponent2 = require('../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _HighlightedItem = require('./HighlightedItem');

var _HighlightedItem2 = _interopRequireDefault(_HighlightedItem);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Highlighter
 *
 * It highlights string type children by wrapping match
 * with strong dom element.
 * It remains children element structure.
 */
var Highlighter = function (_WixComponent) {
  _inherits(Highlighter, _WixComponent);

  function Highlighter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Highlighter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Highlighter.__proto__ || Object.getPrototypeOf(Highlighter)).call.apply(_ref, [this].concat(args))), _this), _this._reactKey = 0, _this._CHILD_TYPES = {
      STRING: 'string',
      ARRAY: 'array',
      REACT_ELEMENT: 'React_element'
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Highlighter, [{
    key: '_isReactElement',
    value: function _isReactElement(element) {
      return element.props !== undefined;
    }
  }, {
    key: '_renderHighlightItem',
    value: function _renderHighlightItem(element, reactKey) {
      return _react2.default.createElement(
        _HighlightedItem2.default,
        {
          match: this.props.match,
          key: 'highlighted-child' + reactKey
        },
        element
      );
    }
  }, {
    key: '_renderArrayOfChildren',
    value: function _renderArrayOfChildren(element, parent) {
      var _this2 = this;

      return element.map(function (child) {
        _this2._reactKey += 1;

        if (_this2._isReactElement(child)) {
          return _this2._highlight(child.props.children, child);
        }

        return _this2._highlight(child, parent);
      });
    }
  }, {
    key: '_getElementType',
    value: function _getElementType(element) {
      var type = '';

      if (Array.isArray(element)) {
        type = this._CHILD_TYPES.ARRAY;
      } else if (this._isReactElement(element)) {
        type = this._CHILD_TYPES.REACT_ELEMENT;
      } else if (typeof element === 'string') {
        type = this._CHILD_TYPES.STRING;
      }

      return type;
    }
  }, {
    key: '_highlight',
    value: function _highlight(element, parent) {
      switch (this._getElementType(element)) {
        case this._CHILD_TYPES.STRING:
          {
            this._reactKey += 1;

            if (parent) {
              return _react2.default.cloneElement(parent, Object.assign({}, parent.props), this._renderHighlightItem(element, this._reactKey));
            }

            return this._renderHighlightItem(element, this._reactKey);
          }
        case this._CHILD_TYPES.REACT_ELEMENT:
          {
            if (parent) {
              return _react2.default.cloneElement(parent, Object.assign({}, { key: 'highlighted-child' + this._reactKey }, parent.props), this._highlight(element.props.children, element));
            }

            return this._highlight(element.props.children, element);
          }
        case this._CHILD_TYPES.ARRAY:
          return this._renderArrayOfChildren(element, parent);
        default:
          return;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        this.props.children && this._highlight(this.props.children)
      );
    }
  }]);

  return Highlighter;
}(_WixComponent3.default);

Highlighter.propTypes = {
  /** match to highlight */
  match: _propTypes2.default.string
};


Highlighter.displayName = 'Highlighter';

exports.default = Highlighter;